/**
 *
 * Paypal
 *
 */

import { mapState, mapActions } from 'vuex';

import { swalSuccess, swalWarning } from '@/utils/swal2';
import { getUrlProtocol } from '@/utils/browser';
import SharedHeader from '@/components/SharedHeader.vue';
import SharedFooter from '@/components/SharedFooter.vue';
import FirstBuy from '@/components/FirstBuy.vue';
import { URL_WWW_PZ_ACADEMY_COM } from '@/constants/index';
import { /* MALL_PAGE */ MALL_PAYPAL_PAGE, DASHBOARD_PAGE } from '@/constants/routes';

export default {
  name: 'Paypal',

  components: {
    SharedHeader,
    SharedFooter,
    FirstBuy,
  },

  data: () => {
    return {
      step: 0,
      checking: false,
      Paypal: {},
      paypalToken: '',
      paypalPayerID: '',
      timerPromiseHide: null,
      timerPromise: null,
      queue: [],
      fromwechat: '',
      mpGoodsId: '',
      vendor_oid: '',
      order_category: '',
      order_activityUrl: '',
      //
      isStep1Needed: null,
      salesQrCode: null,

      promiseGetStudentAndTutorInfo: null,
    };
  },

  computed: {
    ...mapState('Mall/Paypal', {
      ms_isRequest: 'isRequest',
      ms_paypalInfo: 'paypalInfo',
    }),

    c_isFromWechatNotMpGood() {
      return this.fromwechat && !this.mpGoodsId;
    },

    c_vendor_oid() {
      return this.vendor_oid ? this.vendor_oid : undefined;
    },

    c_isActivity() {
      return 5 === this.order_category && this.order_activityUrl;
    },

    c_isStep1Needed() {
      return 'true' === this.isStep1Needed;
    },

    c_isSalesQrCodeNeeded() {
      return this.salesQrCode ? true : false;
    },
  },

  methods: {
    ...mapActions({
      ma_getUserInfo: 'getUserInfo',
      ma_getTutorInfo: 'getTutorInfo',
    }),

    ...mapActions('Mall/Paypal', {
      ma_setPaypalInfo: 'setPaypalInfo',
      ma_getMallPaypalInfo: 'getMallPaypalInfo',
      ma_getMallPaypalResult: 'getMallPaypalResult',
    }),

    showCheckOverlay() {
      this.queue.push({});
      if (this.queue.length === 1) {
        this.timerPromise = setTimeout(() => {
          if (this.queue.length) this.checking = true;
        }, 300);
      }
    },

    hideCheckOverlay() {
      this.queue.pop();
      if (this.queue.length == 0) {
        this.timerPromiseHide = setTimeout(() => {
          if (this.queue.length === 0) {
            this.checking = false;
            if (this.timerPromiseHide) clearTimeout(this.timerPromiseHide);
          }
        }, 300);
      }
    },

    getStudentAndTutorInfo() {
      this.promiseGetStudentAndTutorInfo = Promise.all([
        this.ma_getUserInfo(),
        this.ma_getTutorInfo(),
      ]);
    },

    async confirm() {
      this.showCheckOverlay();
      try {
        const res = await this.ma_getMallPaypalResult({
          token: this.paypalToken,
          vendorId: this.c_vendor_oid,
        });
        if (res.data.data.result) {
          this.getStudentAndTutorInfo();
          this.checkStatusNextStep();
        } else {
          this.step = 3;
        }
      } catch (e) {
        this.step = 3;
      }
      this.hideCheckOverlay();
    },

    async checkStatusNextStep() {
      if (this.step < 9 && this.c_isSalesQrCodeNeeded) {
        this.step = 9;
        return;
      }
      if (this.step < 10 && this.c_isStep1Needed) {
        this.step = 10;
        return;
      }
      if (this.c_isActivity) {
        await swalSuccess('购买成功！');
        await this.promiseGetStudentAndTutorInfo;
        window.location.href = this.order_activityUrl;
      } else {
        this.step = 2;
      }
    },

    gotoMycourses() {
      //const mpGoodsId = window.sessionStorage.getItem('mpGoodsId');
      window.sessionStorage.removeItem('mpGoodsId');
      if (this.fromwechat && this.mpGoodsId) {
        window.sessionStorage.removeItem('fromwechat');
        window.location.href =
          getUrlProtocol() + `mp.pzacademy.com/wx/redirect.html?state=mymini-list`;
      }
      this.$router.push(DASHBOARD_PAGE);
    },

    gotoMall() {
      //const mpGoodsId = window.sessionStorage.getItem('mpGoodsId');
      window.sessionStorage.removeItem('mpGoodsId');
      if (this.fromwechat && this.mpGoodsId) {
        window.sessionStorage.removeItem('fromwechat');
        window.location.href =
          getUrlProtocol() + `mp.pzacademy.com/wx/redirect.html?state=course/${this.mpGoodsId}`;
      }
      //this.$router.push(MALL_PAGE);
      window.location.href = getUrlProtocol() + `${URL_WWW_PZ_ACADEMY_COM}/mall`;
    },

    _compCreated() {
      this.fromwechat = window.sessionStorage.getItem('fromwechat');
      this.fromwechat = this.fromwechat ? this.fromwechat : '';
      this.mpGoodsId = window.sessionStorage.getItem('mpGoodsId');
      this.vendor_oid = window.sessionStorage.getItem('vendor_oid');
      this.order_category = window.sessionStorage.getItem('order_category');
      this.order_activityUrl = window.sessionStorage.getItem('order_activityUrl');
      this.isStep1Needed = window.sessionStorage.getItem('isStep1Needed');
      this.salesQrCode = window.sessionStorage.getItem('salesQrCode');
    },

    async _compMounted() {
      if (this.$route.query.token) {
        this.ma_setPaypalInfo({
          token: this.$route.query.token,
          PayerID: this.$route.query.PayerID,
        });
        this.$router.push(MALL_PAYPAL_PAGE).catch(() => { });
      } else {
        this.paypalToken = this.ms_paypalInfo.token;
        this.paypalPayerID = this.ms_paypalInfo.PayerID;
        this.ma_setPaypalInfo({
          token: '',
          PayerID: '',
        });
        if (this.paypalToken) {
          if (this.paypalPayerID) {
            this.step = 1;
            this.showCheckOverlay();
            try {
              const res = await this.ma_getMallPaypalInfo({
                token: this.paypalToken,
                PayerID: this.paypalPayerID,
              });
              if (200 === res.data.status) {
                this.Paypal = res.data.data;
              }
            } catch (e) {
              swalWarning('paypal付款出现问题');
            }
            this.hideCheckOverlay();
          } else {
            this.step = 3;
          }
        }
      }
    },

    _compBeforeDestroy() {
      window.sessionStorage.removeItem('vendor_oid');
    },
  },

  created() {
    this._compCreated();
  },

  mounted() {
    window.scrollTo(0, 0);
    this._compMounted();
  },

  beforeDestroy() {
    this._compBeforeDestroy();
  },
};
